import i18n, { Ti18nKeys } from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import {
  LANE_HEADER_GAP,
  LANE_HEADER_HEIGHT,
  LANE_HEADER_MARGIN,
  LANE_TITLE_FONT_SIZE
} from "./lane-constants";

const LaneHeader = withLiteObserverAndTheme<{
  children?: React.ReactNode;
  titleKey: Ti18nKeys;
}>((props) => {
  const { children = null, titleKey, theme } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={LANE_HEADER_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        gap: LANE_HEADER_GAP * unitX,
        marginBottom: LANE_HEADER_MARGIN * unitY
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={LANE_TITLE_FONT_SIZE}
        text={i18n.get(titleKey)}
        isSpan={true}
        color={colors.all.maastrichtBlue}
        style={{ margin: 0, whiteSpace: "nowrap" }}
      />
      {children}
    </ET3Div>
  );
});
export default LaneHeader;
